import InvokeAnalysisProduct from "./InvokeAnalysisProduct";

function InvokeStudentSuccess(props) {
    return(<InvokeAnalysisProduct product="InvokeStudentSuccess" />);
}

export default InvokeStudentSuccess;